<button
  [type]="type()"
  [class]="classes()"
  [disabled]="isDisabled()"
  [attr.aria-busy]="loading() || null"
  [attr.aria-label]="ariaLabel()"
>
  @if (loading()) {
    <span class="absolute inset-0 flex items-center justify-center">
      <span
        class="size-4 animate-spin rounded-pill border-2 border-current border-r-transparent"
        aria-hidden="true"
      ></span>
      <span class="sr-only">Loading…</span>
    </span>
  }
  <span class="inline-flex items-center" [class]="contentGap()" [class.invisible]="loading()">
    <ng-content />
  </span>
</button>
